import React, { Component } from 'react';
import { Tabs, Tab, Grid, Cell, Card, CardTitle, CardText, CardActions, Button, CardMenu, IconButton } from 'react-mdl';

class Papers extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  toggleCategories() {

    if(this.state.activeTab === 0){
      return(
        <div className="projects-grid">
          {/* CV */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=1VwCxWoqnKxcq9MqgkbFCriXpp0G7ewvu">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
              <CardText>
              Curriculum Vitae for download.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        </div>
      )
    } else if(this.state.activeTab === 1) {
      return (
         <div className="projects-grid">
          {/* Certificate 0 */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=1HOMM7gITH4Yh-1ksHVZUuoY-BUVPl3W9">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
              <CardText>
              Recommendation letter from my Software Engineer mentor at Finnfjord AS.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

          {/* Certificate 1 */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=1Q5CbtjvF07kEckFjYMT3tAmoGLEjdhZn">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
              <CardText>
               For position as a metal furnace operator at Finnfjord AS.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

          {/* Certificate 2 */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=16fPSg58JeAK9UDn0FsoAC6rRP244g1ri">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
                  <CardText>
                For position as a salesperson at KappAhl Finnsnes.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

             {/* Certificate 3 */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=1lC_acIhYpqHBigIzH2wKZuGVHLayFlXR">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
                  <CardText>
                For position as a Summer intern in Software development at Multiconsult (Skøyen, Oslo).
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        </div>

      )
    } else if(this.state.activeTab === 2) {
      return (

          <div className="projects-grid">
         <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=1NQGCjmEUigvlrnKW0YLbJAf-XwN4BsNW">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
                  <CardText>
                Proof of course completion in ICT safety principles.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        </div>


      )
    } else if(this.state.activeTab === 3) {
      return (
         <div className="projects-grid">
          {/* Grades NTNU */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=17y3LNJYEsDP1kxPAV_zkPowrX5xkmYCZ">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
              <CardText>
              Diploma for M.Sc. in Engineering and ICT.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

             {/* Grades NTNU Economics */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=1ZFDJMzmIxQMo2sFT0bmFtWPDVskuVhhM">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
              <CardText>
              Grades for Bachelor in Economics.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

          {/* Grades USA */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=1LsuMe0uq-Wi8OFHY3L6EHjuLfnrr6SiC">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
              <CardText>
              Grades from Stanley Boyd High School.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>

            {/* Grades Senja */}
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
              <a href="https://drive.google.com/uc?export=download&id=1a26Xo77BQXu-QzRqmYIao2ZKvGBlePbH">
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://github.com/thewildling/Website_photos/blob/main/Images/Download_icon.png?raw=true) center / cover'}} ></CardTitle>
              </a>
              <CardText>
              Grades from Senja Videregående Skole.
            </CardText>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
         </div>
      )
    }
  }

  render() {
    return(
      <div>
        <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({ activeTab: tabId })} ripple>
          <Tab>Curriculum Vitae</Tab>
          <Tab>Recommendations</Tab>
          <Tab>Certificates</Tab>
          <Tab>Grades</Tab>
        </Tabs>
          <Grid>
            <Cell col={12}>
              <div className="content">{this.toggleCategories()}</div>
            </Cell>
          </Grid>
      </div>
    )
  }
}

export default Papers;



// WEBPACK FOOTER //
// ./src/components/papers.js